import { reactive } from 'vue'
import actions from '@/store/stats/actions'
import state from '@/store/stats/state'
import getters from '@/store/stats/getters'

export const statsModule = {
    state: reactive(state),
    actions,
    getters,
}
